import basic from './default.config'
import global from './global.config'

export default {
  basic: basic,
  global: global
}
